var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	},
	innerWrap: function (selector, extraClasses) {
		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selector).wrapInner("<div class='contentWrap " + extraClasses + "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.opnun = {
	init: function() {
		var $element = $("table#opnunartimar-litir");

		if ($element.length) {
			var orgPos = $element.position().top;

			$element.css('top', orgPos);

			$(window).scroll(function (e) {
				site.opnun.update(orgPos);
			});

			$(window).resize(function (e) {
				site.opnun.update(orgPos);
			});

			$element.find('thead').on('click', function () {
				$element.toggleClass('clicked');
			})
		}
	},
	update: function(orgPos) {
		var $element = $("table#opnunartimar-litir"),
			scrollTop = $(window).scrollTop();

		if (scrollTop > orgPos) {
			$element.addClass('stick').stop().animate({
				top: scrollTop + 100
			}, 500);
		}
		else {
			$element.removeClass('stick').stop().animate({
				top: orgPos
			}, 500);
		}
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.opnun.init();
	site.nav.init();
	site.owl.init('#owl-supporters', {
		loop: true,
		nav: false,
		slideBy: 7,
		autoplay: true,
		autoplayTimeout:10000,
		responsive: {
			0:{
				items: 1
			},
			480:{
				items: 2
			},
			768: {
				items: 3
			},
			992:{
				items: 6
			},
			1200: {
				items: 7
			}
		}
	});

	/*
	site.owl.init('.box_galleryimage .boxText > ul', {
		loop: true,
		dots: false,
		slideBy: 1,
		items: 2,
		margin: 40,
		autoplay: true,
		autoplayTimeout:6000,
	});
	*/

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	site.layout.rowWrap('.box_social_facebook', '.box_social_instagram', 'socialWrap');

	// Append searchToggle to navigation
	$(".mmLevel1.last", "#mainmenu").removeClass('last');
	$(".mmLevel1", "#mainmenu").append("<li class='ele-search level1 last' id='searchToggle'><a href='#'><i class='fa fa-search'></i></a></li>");

	$("#searchToggle").on('click', function() {
		var $toggle = $(this),
			$body = $('body');

		if ($body.hasClass('search-open')) {
			$body.removeClass('search-open');
			$toggle.find('.fa').replaceWith('<i class="fa fa-search"></i>')
		}
		else {
			$body.addClass('search-open');
			$toggle.find('.fa').replaceWith('<i class="fa fa-times"></i>')
		}
	});

	$('.status--webcams, .status--store', '#main').on('click', function(e) {
		window.location = $(this).find('a').attr('href');
	});
});
